import React from "react";
import { useFormikContext } from "formik";

const EnhancedTableToolbar = ({ name, label, validation }) => {
  const { errors } = useFormikContext();

  return (
    <>
      <u>
        <b>{label}:</b>
      </u>
      {validation?.mandatory && (
        <span className="mandatory-validation">{"*"}</span>
      )}
      {errors[name + "_Label"] && (
        <span
          className="is-invalid"
          style={{ color: "red", fontSize: "15px", marginLeft: "15px" }}
        >
          {errors[name + "_Label"]}
        </span>
      )}
    </>
  );
};

export default EnhancedTableToolbar;
